<template>	
	<div class="knd-teaser" @mouseover="mouseHandler()" @mouseout="mouseHandler()" @click="mouseClick()">

		<div class="knd-teaser-img-wrapper">
			<img :src='"https://pointer-dev.kro-ncrv.nl/" + imgUrl' class="knd-teaser-img" />
		</div>

		<div class="knd-teaser-titel">
			<p v-html="title"></p>
		</div>

		<img :src='require("@/assets/icons/pijl.svg")' ref="arrow1" class="knd-teaser-arrow visible" />
		<img :src='require("@/assets/icons/pijl_hover.svg")' ref="arrow2" class="knd-teaser-arrow" />
	</div>
</template>

<script>
	import './teaser.scss';

	export default {
		name: 'Teaser',
		props: ['url', 'title', 'imgUrl'],
		computed: {
		},
		data: function() {
			return {
				// data: this.$store.state.data,
			}
		},
		mounted() {
		},
		methods: {
			mouseHandler() {
				this.$refs.arrow1.classList.toggle("visible");
				this.$refs.arrow2.classList.toggle("visible");
			},

			mouseClick() {
				window.open(this.url, '_blank').focus();
			}
		}
	}
</script>